import icon from "images/web/access_applet_card/arrow.svg"

export default function ArrowIcon({ title }) {
  return (
    <span
      className="svg-icon"
      title={title}
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  )
}
